export interface Campaign {
  id: number;
  name: string;
  position: number;
  creative: string;
  marketingType: string;
}

export class Campaign implements Campaign {
  marketingType: string;
  constructor(id: number, name: string, position: number, creative: string, type?: string) {
    this.id = id;
    this.name = name;
    this.position = position;
    this.creative = creative;
    this.marketingType = type ?? "unknown";
  }
}
